export default __webpack_public_path__ + "static/media/easton.c2e41275.png";